import { useEffect, useMemo } from "react";

import { Box, Stack, Typography } from "@mui/material";

import { FilterTable } from "../../../Components/FilterTable/FilterTable";
import { Loader } from "../../../Components/Loader";
import { filters, headerColumns } from "./columns";
import { GCPReportUpdateToolRow } from "./GCPReportUpdateToolRow";
import { useGCPTableUpdates } from "./hooks";
import { ReportUpdateToolForm } from "./ReportUpdateToolForm";
import { type TransformedGCPTableUpdate } from "./types";
import { formatRow } from "./utils";

let timeOut;
const numMs = 5 * 60 * 1000;

export const ReportUpdateTool = () => {
  const { rows, loading, loadRows } = useGCPTableUpdates();

  useEffect(() => {
    const startTimeout = () => {
      clearTimeout(timeOut);
      loadRows();
      timeOut = setTimeout(() => {
        startTimeout();
      }, numMs);
    };

    startTimeout();

    return () => {
      clearTimeout(timeOut);
    };
  }, [loadRows]);

  const formattedRows = useMemo(() => rows.map(formatRow), [rows]);

  return (
    <>
      <Box
        sx={{
          width: "350px",
        }}
      >
        <Stack
          direction="row"
          sx={{
            mt: 2,
            gap: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h1" data-cy="page-title">
            GCP Report Update Tool
          </Typography>
        </Stack>
        <ReportUpdateToolForm loadJobs={loadRows} />
      </Box>
      <Loader loading={loading}>
        <FilterTable<TransformedGCPTableUpdate>
          showRowsSelection={false}
          tableItems={formattedRows}
          wrapRowComponent={true}
          headerColumns={headerColumns}
          rowComponent={GCPReportUpdateToolRow}
          filterColumns={filters}
        />
      </Loader>
    </>
  );
};
